<template>
  <div class="register-page" ref="pageRef">
    <template v-if="showPage">
      <template v-if="!successShow">
        <div class="container">
          <img class="banner-img" :src="registerBanner" />

          <div class="form-content">
            <div class="form-li">
              <input
                class="input-item"
                v-model="phone"
                maxlength="11"
                type="number"
                placeholder="输入手机号码"
                @input="inputHandle('phone')"
                @blur="blurHandle()"
              />
            </div>
            <div class="form-li code-li">
              <input
                class="input-item"
                v-model="code"
                maxlength="6"
                type="number"
                placeholder="输入验证码"
                @input="inputHandle('code')"
              />
              <div class="code-btn" v-show="num === 0" @click="getCodeHandle">
                <span>获取验证码</span>
              </div>
              <div class="code-btn is-reciprocal" v-show="num > 0">{{ num }}s后重试</div>
            </div>
            <div class="error-tip" v-show="currentErrMsg">{{ currentErrMsg }}</div>
            <div class="submit-content">
              <button class="submit-btn" @click="submitHandle">立即预测量刑结果</button>
            </div>
            <div class="footer-tip" @click="argee = !argee">
              <span class="radio-content" :class="argee ? 'is-argee' : ''"></span>
              <span>注册即同意</span>
              <span class="blue-text" @click.stop="showTipHandle('register')">《注册协议》</span>
              <span>和</span>
              <span class="blue-text" @click.stop="showTipHandle('privacy')">《隐私政策》</span>
            </div>
          </div>

          <h3 class="desc-title">
            <span>理论量刑预测与实证刑期分析“双系统”相互验证，说理充分，结果精准</span>
          </h3>

          <div class="video-content">
            <img class="video-mask-img" :src="descMask" />
            <video
              class="video-el"
              ref="videoRef"
              controls
              src="http://www.xiaobaogong.com/audio/智能量刑预测系统视频操作视频.MP4"
              v-if="videoPlay"
            ></video>
            <template v-else>
              <img class="play-btn" :src="playBtn" @click="videoPlay = true" />
              <div class="video-mask" @click="videoPlay = true"></div>
              <img class="video-bg-img" :src="videoBgImg" />
            </template>
          </div>

          <div class="introduction-ul">
            <div class="introduction-item">
              <div class="introduction-item-content">
                <div class="introduction-item-title">
                  <span>国内独创的智能精准量刑双系统</span>
                </div>
                <div class="introduction-item-desc">
                  <span
                    >实现“一次操作、两套结果”。理论量刑预测系统提供实时刑期展示及法律依据，呈现量刑规范化表格;；实证量刑分析系统基于大数据提供案件的可视化分析；双系统之间相互印证，最大程度实现精准量刑。</span
                  >
                </div>
                <div class="introduction-item-preview-img">
                  <img :src="previewImg1" alt="国内独创的智能精准量刑双系统预览" />
                </div>
              </div>
            </div>
            <div class="introduction-item">
              <img class="introduction-bg-img" :src="introductionBgImg1" />
              <div class="introduction-item-content">
                <div class="introduction-item-title">
                  <span>理论量刑预测系统</span>
                </div>
                <div class="introduction-item-sub-title">
                  <span>“小包公”因合规而量刑精准</span>
                </div>
                <div class="introduction-item-desc">
                  <div>
                    <span>依规提炼量刑情节，依规构建量刑规则，根据司法大数据</span>
                  </div>
                  <div>
                    <span
                      >以刑事法律、立法解释、司法解释及各省量刑指导 意见实施细则为依据，通过理论建模、数据运算和智能
                      分析，实现专业、精准的刑期预测。</span
                    >
                  </div>
                </div>
                <div class="introduction-item-tip-content">
                  <img class="tip-icon" :src="icon1" />
                  <div class="tip-title">
                    <span>理论量刑框架</span>
                  </div>
                  <ul class="tip-ul">
                    <li class="tip-li">
                      <span>四要件 — 客体要件、客观方面要件、主体要件、主观方面要件</span>
                    </li>
                    <li class="tip-li">
                      <span>量刑起点、增加量、基准刑、从重从宽情节</span>
                    </li>
                    <li class="tip-li">
                      <span>同向相加异向相减算法、连乘算法</span>
                    </li>
                    <li class="tip-li">
                      <span>减轻情节减档和其他限制算法</span>
                    </li>
                    <li class="tip-li">
                      <span>量刑规范化表格、计算过程展示和调节</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="introduction-item black-bg">
              <img class="introduction-bg-img" :src="introductionBgImg2" />
              <div class="introduction-item-content">
                <div class="introduction-item-title">
                  <span>实证量刑分析系统</span>
                </div>
                <div class="introduction-item-sub-title">
                  <span>“小包公”因实证而量刑精准</span>
                </div>
                <div class="introduction-item-desc">
                  <span
                    >一人多罪、多人多罪情节的精准类案推送类案刑期、罚金、缓刑等多维度可视化分析类案市、省、全国分布地图</span
                  >
                </div>
                <div class="introduction-item-tip-content">
                  <img class="tip-icon" :src="icon2" />
                  <div class="tip-title">
                    <span>大数据、人工智能算法</span>
                  </div>
                  <ul class="tip-ul">
                    <li class="tip-li">
                      <span>被告人、罪名、情节的精准提取</span>
                    </li>
                    <li class="tip-li">
                      <span>自然语言处理（NLP）</span>
                    </li>
                    <li class="tip-li">
                      <span>语义分析</span>
                    </li>
                    <li class="tip-li">
                      <span>模型、实体识别的机器训练</span>
                    </li>
                    <li class="tip-li">
                      <span>起点、情节适用比例的实证分析</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="introduction-item">
              <div class="introduction-item-content">
                <div class="introduction-item-title">
                  <span>精准提取量刑要素</span>
                </div>
                <div class="mulit-tip-ul">
                  <div class="mulit-tip-li">
                    <img class="mulit-tip-icon" :src="icon3" />
                    <div class="mulit-tip-text">
                      <span>支持粘贴、上传等多方式进行提取</span>
                    </div>
                  </div>
                  <div class="mulit-tip-li">
                    <img class="mulit-tip-icon" :src="icon4" />
                    <div class="mulit-tip-text">
                      <span>一人多罪、多人多罪之案情精准识别</span>
                    </div>
                  </div>
                  <div class="mulit-tip-li">
                    <img class="mulit-tip-icon" :src="icon5" />
                    <div class="mulit-tip-text">
                      <span>一键精准提取地区、被告人、罪名、定罪条件、从重情节和从宽情节</span>
                    </div>
                  </div>
                  <div class="mulit-tip-li">
                    <img class="mulit-tip-icon" :src="icon6" />
                    <div class="mulit-tip-text">
                      <span>主动排除干扰情节，同时支持手动修改量刑要素</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="introduction-item">
              <img class="introduction-bg-img" :src="introductionBgImg3" />
              <div class="introduction-item-content">
                <div class="introduction-item-title">
                  <span>量刑规范化表格</span>
                </div>
                <div class="introduction-item-desc">
                  <span
                    >详尽展示量刑计算公式、过程、结果及依据量刑起点、情节比例调节，个案差异化裁量功能缓刑、剥夺政治权利、没收财产选项</span
                  >
                </div>
                <div class="introduction-item-preview-img">
                  <img :src="previewImg2" alt="量刑规范化表格" />
                </div>
              </div>
            </div>
            <div class="introduction-item">
              <div class="introduction-item-content">
                <div class="introduction-item-title">
                  <span>精准预测罚金刑数额</span>
                </div>
                <div class="introduction-item-desc">
                  <span
                    >严守罚金刑法定范围，智能推演罚金刑司法适用大数据，科学预测个案罚金刑适用数额，从而满足量刑精准要求。</span
                  >
                </div>
                <div class="introduction-item-preview-img">
                  <img :src="previewImg3" alt="精准预测罚金刑数额" />
                </div>
              </div>
            </div>
            <div class="introduction-item">
              <img class="introduction-bg-img" :src="introductionBgImg4" />
              <div class="introduction-item-content">
                <div class="introduction-item-title">
                  <span>精准预测数罪并罚结果</span>
                </div>
                <div class="introduction-item-desc">
                  <span
                    >经过深入论证和大数据推演，探索出实现数罪并罚“酌情决定执行的刑期”的最优路径，实现对并罚结果的精准测算。</span
                  >
                </div>
                <div class="introduction-item-preview-img">
                  <img :src="previewImg4" alt="精准预测数罪并罚结果" />
                </div>
              </div>
            </div>
            <div class="introduction-item">
              <div class="introduction-item-content">
                <div class="introduction-item-title">
                  <span>国内首创实用量刑协商工具</span>
                </div>
                <div class="introduction-item-desc">
                  <span
                    >系统确认了认罪认罚从宽量刑情节属性，并将其按4个阶段进行精细化分类，为控辩双方提供量刑协商可视化、可量化、可操作的工具</span
                  >
                </div>
                <div class="introduction-item-preview-img">
                  <img :src="previewImg5" alt="国内首创实用量刑协商工具" />
                </div>
              </div>
            </div>
            <div class="introduction-item">
              <img class="introduction-bg-img" :src="introductionBgImg5" />
              <div class="introduction-item-content">
                <div class="introduction-item-title">
                  <span>多维度、可拆分的刑事文书查询，实现精准的智能化类案推送</span>
                </div>
                <div class="introduction-item-desc">
                  <span
                    >建构多维度、可拆分刑事文书查询系统;每次预测，根据提取罪名、情节智能推送同地区、同条件的前10个类案，极大缩减了全网检索的时间，实现高、精、准的类案推送。</span
                  >
                </div>
                <div class="introduction-item-preview-img">
                  <img :src="previewImg6" alt="多维度、可拆分的刑事文书查询，实现精准的智能化类案推送" />
                </div>
              </div>
            </div>
          </div>

          <div class="footer-btn-content" @click="scrollTopHandle">
            <div class="btn-content">
              <span>立即预测量刑结果</span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="success-pane">
          <div class="success-img">
            <img :src="successImg" />
          </div>
          <div class="bottom-mask"></div>
          <div class="success-text">
            <span v-if="isRegister">您已注册成功</span>
            <span v-else>注册成功</span>
          </div>
          <div class="tip-text tip-text1">请使用电脑浏览器登录小包公官网试用</div>
          <div class="tip-text tip-text2">(www.xiaobaogong.com)</div>
          <div class="tip-text tip-text3">立即开始预测量刑结果！</div>
        </div>
      </template>
    </template>

    <tip-modal :show.sync="tipModal.show" :mode="tipModal.mode" />
  </div>
</template>

<script>
import tipModal from '@/components/registerComponents/tipModal';

import successImg from '@/assets/img/successImg.png';
import registerBanner from '@/assets/img/thirdParty/sentencing/registerBanner.png';
import videoBgImg from '@/assets/img/thirdParty/sentencing/videoBgImg.png';
import previewImg1 from '@/assets/img/thirdParty/sentencing/previewImg1.png';
import previewImg2 from '@/assets/img/thirdParty/sentencing/previewImg2.png';
import previewImg3 from '@/assets/img/thirdParty/sentencing/previewImg3.png';
import previewImg4 from '@/assets/img/thirdParty/sentencing/previewImg4.png';
import previewImg5 from '@/assets/img/thirdParty/sentencing/previewImg5.png';
import previewImg6 from '@/assets/img/thirdParty/sentencing/previewImg6.png';
import icon1 from '@/assets/img/thirdParty/sentencing/icon1.png';
import icon2 from '@/assets/img/thirdParty/sentencing/icon2.png';
import icon3 from '@/assets/img/thirdParty/sentencing/icon3.png';
import icon4 from '@/assets/img/thirdParty/sentencing/icon4.png';
import icon5 from '@/assets/img/thirdParty/sentencing/icon5.png';
import icon6 from '@/assets/img/thirdParty/sentencing/icon6.png';
import introductionBgImg1 from '@/assets/img/thirdParty/sentencing/introductionBgImg1.png';
import introductionBgImg2 from '@/assets/img/thirdParty/sentencing/introductionBgImg2.png';
import introductionBgImg3 from '@/assets/img/thirdParty/sentencing/introductionBgImg3.png';
import introductionBgImg4 from '@/assets/img/thirdParty/sentencing/introductionBgImg4.png';
import introductionBgImg5 from '@/assets/img/thirdParty/sentencing/introductionBgImg5.png';
import descMask from '@/assets/img/register/descMask.png';
import playBtn from '@/assets/img/register/playBtn.png';
import { services } from '@/service';

let timeController = 0;
let currentFontSize = '';

export default {
  components: { tipModal },
  data() {
    return {
      registerBanner,
      videoBgImg,
      previewImg1,
      previewImg2,
      previewImg3,
      previewImg4,
      previewImg5,
      previewImg6,
      icon1,
      icon2,
      icon3,
      icon4,
      icon5,
      icon6,
      introductionBgImg1,
      introductionBgImg2,
      introductionBgImg3,
      introductionBgImg4,
      introductionBgImg5,
      playBtn,
      successImg,
      descMask,
      argee: true,
      phone: '',
      code: '',
      num: 0,
      isFetch: false,
      errMsg: {
        phone: '',
        code: ''
      },
      loading: false,
      codeLoading: false,
      successShow: false,
      isRegister: false,
      videoPlay: false,
      tipModal: {
        show: false,
        mode: ''
      },
      showPage: false,
      wechatCode: ''
    };
  },
  computed: {
    currentErrMsg() {
      let msg = '';
      Object.keys(this.errMsg).forEach(key => {
        if (this.errMsg[key]) {
          msg = this.errMsg[key];
        }
      });
      return msg;
    }
  },
  watch: {
    async videoPlay(val) {
      if (!val) {
        return;
      }
      await this.$nextTick();
      this.$refs.videoRef.play();
    }
  },
  mounted() {
    const body = document.getElementsByTagName('html')[0];
    currentFontSize = body.style.fontSize;
    this.resizeFontSize();
    window.addEventListener('resize', this.resizeFontSize);

    this.wechatCode = this.$route.query.wechatCode;
    if (this.wechatCode) {
      this.checkWechatBind();
    } else {
      this.showPage = true;
      this.isRegister = !!localStorage.getItem('sentencing_is_register');
      if (this.isRegister) {
        this.successShow = true;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeFontSize);
  },
  destroyed() {
    this.setBodyFontSize(currentFontSize);
  },
  methods: {
    async checkWechatBind() {
      try {
        await this.$store.dispatch('login', { params: { code: this.wechatCode, type: 'official_accounts' } });
        await this.$store.dispatch('getUserInfo');
        if (this.$store.getters.userInfo && this.$store.getters.userInfo.tel) {
          window.location.href = `${window.location.origin}/wechat/index.html#/login?token=${this.$store.getters.token}`;
        } else {
          this.showPage = true;
        }
      } catch (err) {
        if (err.message === '未绑定手机号') {
          this.showPage = true;
        }
        console.log(err);
      }
    },
    showTipHandle(mode) {
      this.tipModal = { show: true, mode };
    },
    scrollTopHandle() {
      this.$refs.pageRef.scrollTop = 0;
    },
    resizeFontSize() {
      const docWidth = document.documentElement.clientWidth;
      this.setBodyFontSize(docWidth / 37.5 + 'px');
    },
    setBodyFontSize(val) {
      const body = document.getElementsByTagName('html')[0];
      body.style.fontSize = val;
    },
    blurHandle() {
      if (this.phone.length !== 11) {
        this.errMsg.phone = '请输入正确手机号码';
      } else {
        this.errMsg.phone = '';
      }
    },
    inputHandle(type) {
      if (type === 'phone') {
        this.phone = this.phone.slice(0, 11);
      }
      if (type === 'code') {
        this.code = this.code.slice(0, 6);
      }
    },
    async getCodeHandle() {
      if (!this.phone) {
        this.errMsg.phone = '请输入正确手机号码';
        return;
      }
      if (this.errMsg.phone) {
        return;
      }
      if (this.codeLoading) {
        return;
      }
      try {
        this.codeLoading = true;
        await services.authriozation.getSmsCode({ tel: this.phone });
        this.isFetch = true;
        this.timeoutHandle();
      } catch (err) {
        this.errMsg.code = err.message;
      } finally {
        this.codeLoading = false;
      }
    },
    async submitHandle() {
      if (!this.argee) {
        this.errMsg.phone = '请勾选同意隐私政策';
        return;
      }
      if (!this.phone) {
        this.errMsg.phone = '请输入正确手机号码';
        return;
      }
      if (!this.code) {
        this.errMsg.code = '请输入验证码';
        return;
      }
      if (!this.isFetch) {
        this.errMsg.code = '请获取验证码';
        return;
      }
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        const regUrl = window.location.href;
        await this.$store.dispatch('valid', { tel: this.phone, code: this.code, regUrl });
        if (this.wechatCode) {
          await services.authriozation.setUserInfo({
            ...this.$store.getters.userInfo,
            tel: this.phone,
            validCode: this.code
          });
        } else {
          localStorage.setItem('sentencing_is_register', 1);
        }
        window.location.href = `${window.location.origin}/wechat/index.html#/login?token=${this.$store.getters.token}`;
      } catch (err) {
        this.errMsg.code = err.message;
      } finally {
        this.loading = false;
      }
    },
    timeoutHandle() {
      this.num = 60;
      timeController = setInterval(() => {
        this.num--;
        if (this.num === 0) {
          clearInterval(timeController);
          timeController = 0;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: none;
}

input {
  -webkit-appearance: none;
}

@function rem($px) {
  @return $px * 0.1rem;
}

.success-pane {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f8fafd;

  .success-img {
    width: rem(60);
    height: rem(60);
    font-size: 0;
    margin: rem(100) auto rem(10);

    & > img {
      width: 100%;
      height: 100%;
    }
  }

  .bottom-mask {
    width: rem(36);
    height: rem(4);
    border-radius: 50%;
    background-color: #d9dde4;
    margin: 0 auto;
  }

  .success-text {
    color: #222222;
    font-size: rem(18);
    line-height: rem(28);
    text-align: center;
    margin-top: rem(10);
    font-weight: 300;
  }

  .tip-text {
    font-size: rem(16);
    color: #3d465a;
    text-align: center;
    font-weight: 300;
    &.tip-text1 {
      margin-top: rem(40);
    }
    &.tip-text2 {
      margin-top: rem(6);
    }
    &.tip-text3 {
      margin-top: rem(12);
    }
  }
}
.register-page {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
  user-select: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .container {
    position: relative;
    padding: rem(315) rem(20) rem(30);
    background-color: #fff;

    .banner-img {
      position: absolute;
      top: rem(-10);
      left: rem(-10);
      width: calc(100% + #{rem(20)});
      z-index: 1;
    }

    .form-content {
      box-sizing: border-box;
      position: relative;
      padding: rem(27);
      border-radius: rem(9);
      box-shadow: rem(0) rem(3) rem(16) rem(3) rgba(0, 0, 0, 0.1);
      background-color: #fff;
      z-index: 2;

      .error-tip {
        font-size: rem(14);
        color: #e42626;
        height: rem(20);
        line-height: rem(20);
        margin-top: rem(10);
      }

      .submit-content {
        margin-top: rem(20);

        .submit-btn {
          width: 100%;
          color: #fff;
          font-size: rem(14);
          line-height: rem(43);
          border-radius: rem(22);
          background-color: #e42626;
          border: 0;
          cursor: pointer;
          box-shadow: 0 rem(6) rem(16) rem(4) rgba(48, 52, 58, 0.1);
        }
      }

      .footer-tip {
        width: 100%;
        text-align: center;
        color: #77839e;
        font-size: rem(14);
        line-height: rem(20);
        z-index: 10;
        background-color: #fff;
        margin-top: rem(20);

        .blue-text {
          color: #e42626;
        }

        .radio-content {
          box-sizing: border-box;
          display: inline-block;
          position: relative;
          top: rem(2);
          width: rem(14);
          height: rem(14);
          border: rem(1) solid #a0acc0;
          margin-right: rem(4);
          border-radius: 50%;
          overflow: hidden;
          transform: scale(0.9);
          background-color: #fff;

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: rem(4);
            height: rem(4);
            background-color: #fff;
            border-radius: 50%;
          }

          &::before {
            content: '';
            display: none;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: #e42626;
            border-radius: 50%;
          }

          &.is-argee {
            border: 0;
            &::before {
              display: block;
            }
          }
        }
      }

      .form-li {
        display: flex;
        margin-top: rem(20);

        &:first-child {
          margin-top: 0;
        }

        .input-item {
          box-sizing: border-box;
          flex: 1;
          width: 0;
          padding: rem(10) rem(12);
          font-size: rem(14);
          border-radius: rem(2);
          border: rem(1) solid rgba(#a0acc0, 0.8);
          color: rgba(#2c3443, 0.8);

          &::-webkit-input-placeholder {
            color: rgba(#a8b2c3, 0.6);
          }
        }

        .code-btn {
          box-sizing: border-box;
          width: rem(87);
          height: rem(44);
          font-size: rem(14);
          line-height: rem(44);
          color: #e42626;
          text-align: center;
          cursor: pointer;
          border: rem(1) solid rgba(#a0acc0, 0.8);
          border-radius: rem(2);

          &.is-reciprocal {
            color: rgba(#a8b2c3, 0.6);
          }
        }

        &.code-li {
          .input-item {
            border-right: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }

          .code-btn {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
    }

    .desc-title {
      position: relative;
      font-size: rem(20.5);
      line-height: rem(34);
      text-align: center;
      margin: rem(50) 0 rem(20);
      color: #2c3443;
      z-index: 2;

      & > span {
        font-weight: 600;
      }
    }

    .video-content {
      position: relative;
      width: 100%;
      height: rem(190);
      border-radius: rem(6);
      overflow: hidden;

      .video-mask-img {
        position: absolute;
        left: rem(-20);
        bottom: rem(70);
        width: calc(100% + #{rem(40)});
        z-index: 1;
      }

      .video-el {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 2;
      }

      .play-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: rem(54);
        height: rem(54);
        z-index: 5;
      }

      .video-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(#000, 0.2);
        z-index: 4;
      }

      .video-text {
        position: absolute;
        top: rem(72);
        left: rem(25);
        color: #001529;
        font-size: rem(16);
        line-height: rem(23);
        z-index: 3;

        & > div {
          font-weight: 450;
        }
      }

      .video-bg-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
      }
    }

    .introduction-ul {
      margin-top: rem(50);

      .introduction-item {
        position: relative;
        margin: 0 0 rem(50);
        padding-bottom: rem(15);

        &:last-child {
          padding-bottom: 0;
        }

        .introduction-bg-img {
          position: absolute;
          top: 0;
          left: rem(-20);
          width: calc(100% + #{rem(40)});
          height: calc(100% + #{rem(50)});
          object-fit: cover;
          z-index: 1;
        }

        .introduction-item-content {
          position: relative;
          z-index: 2;

          .introduction-item-title {
            position: relative;
            color: #222222;
            font-size: rem(21);
            line-height: rem(32.5);
            padding-top: rem(50);
            padding-bottom: rem(5);
            margin-bottom: rem(7);

            & > span {
              font-weight: 500;
            }

            &::after {
              content: '';
              position: absolute;
              left: 0;
              bottom: 0;
              width: rem(24);
              height: rem(2);
              background-color: #e42626;
            }
          }

          .introduction-item-sub-title {
            color: rgba(#222222, 0.9);
            font-size: rem(16);
            line-height: rem(23);
            margin-top: rem(16);
          }

          .introduction-item-desc {
            color: #666666;
            font-size: rem(13);
            line-height: rem(20);
            margin-top: rem(12);
          }

          .introduction-item-preview-img {
            margin-top: rem(40);

            & > img {
              width: 100%;
            }
          }

          .introduction-item-tip-content {
            position: relative;
            padding: rem(15);
            padding-left: rem(60);
            margin-top: rem(40);
            background-color: #fff;
            border: rem(1) solid rgba(#ccc, 0.6);
            border-radius: rem(4);

            .tip-icon {
              position: absolute;
              top: rem(15);
              left: rem(15);
              width: rem(25);
              height: rem(25);
            }
            .tip-title {
              color: #222;
              font-size: rem(14);
              line-height: rem(20);

              & > span {
                font-weight: 500;
              }
            }
            .tip-ul {
              padding-left: rem(20);
              margin-top: rem(10);
              .tip-li {
                font-size: rem(12);
                line-height: rem(18);
                color: #666666;
                margin-top: rem(5);
                list-style-type: circle;

                &::marker {
                  font-size: rem(20);
                }

                & > span {
                  position: relative;
                  top: rem(-3);
                  left: rem(-5);
                }
              }
            }
          }

          .mulit-tip-ul {
            margin-top: rem(20);
            display: flex;
            flex-wrap: wrap;

            .mulit-tip-li {
              box-sizing: border-box;
              width: 50%;
              padding: rem(10) rem(15);
              text-align: center;
              .mulit-tip-icon {
                width: rem(25);
                height: rem(25);
              }
              .mulit-tip-text {
                margin-top: rem(9);
                font-size: rem(12);
                line-height: rem(18);
                color: #222222;
                & > span {
                  font-weight: 300;
                }
              }
            }
          }
        }

        &.black-bg {
          .introduction-item-title,
          .introduction-item-sub-title,
          .introduction-item-desc {
            color: #fff;
          }
          .introduction-item-desc {
            font-weight: 300;
            span {
              font-weight: 300;
            }
          }
        }
      }
    }

    .footer-btn-content {
      padding: rem(30) 0 0;

      .btn-content {
        color: #fff;
        line-height: rem(43);
        font-size: rem(14);
        text-align: center;
        box-shadow: 0 rem(3) rem(7) rem(2) rgba(48, 52, 58, 0.04);
        background-color: #e42626;
        border-radius: rem(22);
      }
    }
  }
}
</style>
